import { defineStore } from "pinia";
import Cookies from "js-cookie";

interface UserActivities {
  settingDropDown: boolean;
  localDropDown: boolean;
  freeYoutubeService: boolean;
  beforePay: string | null;
  supportMessageInput: string | '';
  showCalculator: boolean;
}

export const useUserActivities = defineStore("userActivities", {
  state: (): UserActivities => ({
    settingDropDown: false,
    localDropDown: false,
    freeYoutubeService: false,
    beforePay: Cookies.get("beforePay") || (null as string | null),
    supportMessageInput: '',
    showCalculator: false,
  }),

  actions: {
    setDropDown(showSettingDropDown: boolean): void {
      this.settingDropDown = showSettingDropDown;
    },
    setLocalDropDown(showLocalDropDown: boolean): void {
      this.localDropDown = showLocalDropDown;
    },
    setCalculator(value: boolean): void {
      this.showCalculator = value;
    },
    setFreeYoutube(freeYoutubeService: boolean): void {
      this.freeYoutubeService = freeYoutubeService;
    },
    setComingFrom(from: string | null): void {
      this.beforePay = from;
      if (Cookies.get("permittedCookies") === "true") {
        if (from === null) {
          Cookies.remove("beforePay");
        } else {
          Cookies.set("beforePay", from);
        }
      }
    },
  },
});
